<h2 mat-dialog-title>{{sku}}</h2>
<h3>{{columnName}}</h3>
<mat-dialog-content class="mat-typography">
  <ag-grid-angular
    class="ag-theme-alpine"
    style="height: 300px;"
    [serverSideFilterOnServer]="true"
    [pagination]="false"
    [paginationPageSize]="paginationPageSize"
    [cacheBlockSize]="cacheBlockSize"
    [maxBlocksInCache]="maxBlocksInCache"
    [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
    [rowModelType]="rowModelType"
    [defaultColDef]="defaultColDef"
    [rowClassRules]="rowClassRules"
    [columnDefs]="columnDefs"
    [rowData]="rowData"
    [suppressRowClickSelection]="true"
    [animateRows]="false"
    [rowSelection]="rowSelection"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
